export default __webpack_public_path__ + "images/852bad5572d9246ae07794b137c86f61.svg";